import React from 'react';
import styles from './EmbeddedProductNotExistingError.module.css';
const EmbeddedProductNotExistingError = () => <main aria-label="inbäddad videouppspelare" data-sentry-component="EmbeddedProductNotExistingError" data-sentry-source-file="EmbeddedProductNotExistingError.tsx">
    <figure className={styles.playerContainer}>
      <div className={styles.playerNotAvailable}>
        <h1 className={styles.title}>Programmet finns inte</h1>
        <p className={styles.message}>
          Programmet som du försökte nå är tyvärr borttaget eller felaktigt.
        </p>
        <p className={styles.message}>
          Gå vidare till{' '}
          <a className={styles.link} href="https://www.urplay.se">
            UR Play
          </a>
        </p>
      </div>
    </figure>
  </main>;
export default EmbeddedProductNotExistingError;